export enum CtrlDevice {
  Keyboard = 0,
  Gamepad_1 = 1,
  Gamepad_2 = 2,
  Gamepad_3 = 3,
  Gamepad_4 = 4,
  TouchScreen = 5
}
export const CtrlDeviceDescriptions: Record<CtrlDevice, string> = {
  [CtrlDevice.Keyboard]: "",
  [CtrlDevice.Gamepad_1]: "",
  [CtrlDevice.Gamepad_2]: "",
  [CtrlDevice.Gamepad_3]: "",
  [CtrlDevice.Gamepad_4]: "",
  [CtrlDevice.TouchScreen]: "",
}
